// src/components/ContactForm.jsx
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const ContactForm = () => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  
  const [isSending, setIsSending] = useState(false);
  const [feedback, setFeedback] = useState({ message: '', type: '' });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSending(true);
    setFeedback({ message: '', type: '' });

    try {
      const response = await fetch('/includes/send_contact.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (data.success) {
        setFeedback({ message: '✅ Message sent successfully!', type: 'success' });
        setFormData({ name: '', email: '', subject: '', message: '' });
      } else {
        setFeedback({ message: data.message || '❌ An error occurred.', type: 'error' });
      }
    } catch (error) {
      setFeedback({ message: '❌ An error occurred.', type: 'error' });
    } finally {
      setIsSending(false);
      setTimeout(() => setFeedback({ message: '', type: '' }), 5000);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="glass-effect rounded-xl md:rounded-2xl p-6 md:p-8 space-y-5">
      <div className="grid md:grid-cols-2 gap-4">
        <input
          type="text"
          name="name"
          placeholder={`${t('contact.name')} *`}
          value={formData.name}
          onChange={handleChange}
          required
          className="w-full px-4 py-2 bg-white/5 border border-white/10 rounded-lg focus:outline-none focus:border-primary transition text-white"
        />
        <input
          type="email"
          name="email"
          placeholder={`${t('contact.email')} *`}
          value={formData.email}
          onChange={handleChange}
          required
          className="w-full px-4 py-2 bg-white/5 border border-white/10 rounded-lg focus:outline-none focus:border-primary transition text-white"
        />
      </div>
      <input
        type="text"
        name="subject"
        placeholder={`${t('contact.subject')} *`}
        value={formData.subject}
        onChange={handleChange}
        required
        className="w-full px-4 py-2 bg-white/5 border border-white/10 rounded-lg focus:outline-none focus:border-primary transition text-white"
      />
      <textarea
        name="message"
        rows="5"
        placeholder={t('contact.messagePlaceholder')}
        value={formData.message}
        onChange={handleChange}
        required
        className="w-full px-4 py-2 bg-white/5 border border-white/10 rounded-lg focus:outline-none focus:border-primary transition text-white"
      ></textarea>
      
      {feedback.message && (
        <div className={`text-center p-2 rounded-lg ${
          feedback.type === 'success' ? 'bg-green-500/20 text-green-400' : 'bg-red-500/20 text-red-400'
        }`}>
          {feedback.message}
        </div>
      )}
      
      <button
        type="submit"
        disabled={isSending}
        className="w-full py-3 bg-gradient-to-r from-primary to-secondary rounded-lg font-semibold text-white hover-glow transition disabled:opacity-50"
      >
        {isSending ? '⏳ Sending...' : '✉️ Send Message'}
      </button>
    </form>
  );
};

export default ContactForm;